<template>
  <div
    v-if="visible"
    class="jump-to-group d-flex align-center"
  >
    <v-menu
      v-model="menuOpen"
      :close-on-content-click="true"
      offset-y
      nudge-bottom="6"
      min-width="250"
      max-width="420"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          outlined
          class="text-none"
          :color="menuOpen ? 'primary' : 'default'"
          v-bind="attrs"
          v-on="on"
        >
          <font-awesome-icon
            :icon="['fas', 'location-crosshairs']"
            size="sm"
            class="mr-1"
          />
          Jump to Group
        </v-btn>
      </template>

      <v-card class="jump-to-group-popover">
        <div class="jump-to-group-header py-3 px-4 d-flex align-center">
          <font-awesome-icon
            :icon="['fas', 'location-crosshairs']"
            size="sm"
            class="mr-2"
          />
          <span class="subtitle-2 font-weight-medium">Jump to Group</span>
        </div>

        <v-divider />

        <div class="jump-to-group-content pa-4">
          <div class="caption mb-3 grey--text">
            Click a group to scroll to it in the table.
          </div>

          <v-list dense>
            <v-list-item
              v-for="group in groups"
              :key="getGroupName(group)"
              @click="onGroupClick(getGroupKey(group))"
            >
              <v-list-item-icon class="mr-2">
                <font-awesome-icon
                  :icon="['fas', 'location-crosshairs']"
                  class="primary--text"
                />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ getGroupLabel(group) }}
                  <span
                    v-if="group.labels && group.labels.length > 1"
                    class="caption grey--text"
                  >
                    :: {{ group.labels.slice(1).join(' :: ') }}
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle class="caption">
                  {{ group.items ? group.items.length : 0 }} {{ (group.items && group.items.length === 1) ? 'item' : 'items' }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="!groups || groups.length === 0">
              <v-list-item-content>
                <v-list-item-title class="grey--text text-center">
                  No groups to navigate
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'JumpToGroup',
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      menuOpen: false,
    }
  },
  computed: {
    visible() {
      return this.groups && this.groups.length >= 2
    },
  },
  methods: {
    getGroupKey(group) {
      return group.key || group.groupName || group.name
    },
    getGroupName(group) {
      return group.groupName || group.name || group.key
    },
    getGroupLabel(group) {
      if (group.labels && group.labels.length > 0) return group.labels[0]
      return group.name || group.groupName || group.key
    },
    onGroupClick(groupName) {
      this.menuOpen = false
      this.$emit('scroll-to-group', groupName)
    },
  },
}
</script>

<style scoped lang="scss">
.jump-to-group {
  position: relative;
  z-index: 20;
}

.jump-to-group-popover {
  max-height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
}

.jump-to-group-header {
  flex-shrink: 0;
  background-color: #fafafa;
}

.theme--dark .jump-to-group-header {
  background-color: #2d2d2d;
}

.jump-to-group-content {
  overflow-y: auto;
  flex: 1 1 auto;
  max-height: calc(100vh - 340px);
}
</style>
